import SectionHeader from "@/components/SectionHeader";
import JsonLd from "@/components/common/JsonLd";

/**
 * "Wie funktioniert eine Fotobox" und "Aufbau" summieren sich in der Search
 * Console auf gut 5.000 Impressionen — und es ist die Frage, die zwischen
 * Interesse und Anfrage steht: Was kommt eigentlich auf mich zu?
 *
 * Als HowTo ausgezeichnet, weil es tatsächlich eine Anleitung ist. Die
 * Schritte sind bewusst der echte Ablauf dieser Seite und keine
 * Marketing-Etappen ("Träume verwirklichen").
 */

const SCHRITTE = [
  {
    titel: "Termin und Gästezahl eingeben",
    text: "Damit fallen Boxen weg, deren Versand für euren Termin zu knapp wird — und der Drucker passt zur Zahl der Gäste.",
  },
  {
    titel: "Angebote vergleichen",
    text: "Kamera, Licht, Druck und Preis stehen bei allen Anbietern nach denselben Kriterien nebeneinander. Bei regionalen Anbietern siehst du die Anfahrtskosten für deine Postleitzahl.",
  },
  {
    titel: "Unverbindlich anfragen",
    text: "Du schickst deine Anfrage an den Anbieter. Er bestätigt, ob die Box an eurem Termin frei ist — meist innerhalb eines Tages.",
  },
  {
    titel: "Feiern und zurückschicken",
    text: "Die Box kommt per Paket oder wird aufgebaut. Nach der Feier geht sie mit dem beiliegenden Retourenschein zurück oder wird abgeholt.",
  },
];

export default function AblaufSektion() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: "In vier Schritten zur Fotobox",
    description:
      "Von der Suche bis zur Rückgabe: So läuft das Mieten einer Fotobox über FotoboxGuru ab.",
    step: SCHRITTE.map((s, i) => ({
      "@type": "HowToStep",
      position: i + 1,
      name: s.titel,
      text: s.text,
    })),
  };

  return (
    <>
      <JsonLd id="ablauf" data={schema} />
      <SectionHeader
        id="ablauf"
        title="In vier Schritten zur Fotobox"
        subtitle="Vom Vergleich bis zur Rückgabe — was tatsächlich passiert."
      >
        <ol className="mx-auto mt-8 grid max-w-4xl gap-4 text-left sm:grid-cols-2">
          {SCHRITTE.map((s, i) => (
            <li
              key={s.titel}
              className="rounded-2xl bg-slate-50 p-5 ring-1 ring-slate-200/70"
            >
              <span className="font-mono text-xs font-semibold text-[#FF5744]">
                Schritt {i + 1}
              </span>
              <h3 className="mt-1 text-base font-semibold text-slate-900">
                {s.titel}
              </h3>
              <p className="mt-2 text-sm leading-6 text-slate-600">{s.text}</p>
            </li>
          ))}
        </ol>
      </SectionHeader>
    </>
  );
}
